import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Chip } from "@mui/material";
import React from "react";
import { getUserPurchases } from "../Api";
import UserPurchaseDto from "../models/dtos/UserPurchaseDto";

interface PurchasesTableProps {
    userId: number;
}

export default function PurchasesTable(props: PurchasesTableProps) {

    const [state, setState] = React.useState({
        purchases: [] as UserPurchaseDto[],
        loaded: false
    });

    const fetchData = async () => {
        let purchases = await getUserPurchases(props.userId);
        setState(prevState => ({ ...prevState, purchases: purchases ?? [], loaded: true }));
    }

    React.useEffect(() => {
        fetchData();
    }, []);

    return (
        !state.loaded ? <CircularProgress size='100px' style={{ marginBottom: '32px' }} /> : <Table>
            <TableHead>
                <TableRow>
                    <TableCell align="left">ID</TableCell>
                    <TableCell align="left">Product</TableCell>
                    <TableCell align="left">Icon</TableCell>
                    <TableCell align="left">Store Type</TableCell>
                    <TableCell align="left">Store Code</TableCell>
                    <TableCell align="left">Betcoins Received</TableCell>
                    <TableCell align="left">Balance Before</TableCell>
                    <TableCell align="left">Balance After</TableCell>
                    <TableCell align="left">Purchase Date</TableCell>
                    <TableCell align="left">Price</TableCell>
                    <TableCell align="left">Flags</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {state.purchases.length === 0 ? (
                    <TableRow>
                        <TableCell colSpan={11} align="center">No purchases found</TableCell>
                    </TableRow>
                ) : (
                    state.purchases.map(item => (
                        <TableRow key={item.id}>
                            <TableCell>{item.id}</TableCell>
                            <TableCell>{item.productTitle || '-'}</TableCell>
                            <TableCell>
                                {item.iconUrl ? (
                                    <img src={item.iconUrl} width={32} height={32} alt="Product icon" />
                                ) : '-'}
                            </TableCell>
                            <TableCell>{item.storeType}</TableCell>
                            <TableCell>{item.storeCode || '-'}</TableCell>
                            <TableCell><b>+{item.betcoinsReceived}</b></TableCell>
                            <TableCell>{item.balanceBefore.toFixed(2)}</TableCell>
                            <TableCell>{item.balanceAfter.toFixed(2)}</TableCell>
                            <TableCell>
                                {item.purchaseDate ? new Date(item.purchaseDate).toLocaleString() : '-'}
                            </TableCell>
                            <TableCell>{item.price ? `$${item.price}` : '-'}</TableCell>
                            <TableCell>
                                {item.purchaseKind === 'SUBSCRIPTION_INITIAL' && (
                                    <Chip label={`Subscription #${item.subscriptionId}`} color="primary" size="small" style={{ marginRight: 4 }} />
                                )}
                                {item.purchaseKind === 'SUBSCRIPTION_RENEWAL' && (
                                    <Chip label={`Renewal · sub #${item.subscriptionId}`} color="primary" variant="outlined" size="small" style={{ marginRight: 4 }} />
                                )}
                                {item.isFirstPurchase && (
                                    <Chip label="First" color="success" size="small" style={{ marginRight: 4 }} />
                                )}
                                {item.isTestPurchase && (
                                    <Chip label="Test" color="warning" size="small" />
                                )}
                            </TableCell>
                        </TableRow>
                    ))
                )}
            </TableBody>
        </Table>);
}
